/* istanbul ignore file */
import { EnumField, useFieldHelper, FieldProps } from 'framework/ui/field';
import { BASE_AMOUNT_TYPES } from 'domain/shared/employee';

const BaseAmountTypeField = ({ value: inputValue, source, label }: FieldProps) => {
  const { getValue } = useFieldHelper({ value: inputValue, source });

  const value = inputValue || (getValue && getValue());

  return <EnumField label={label} value={value} options={BASE_AMOUNT_TYPES} />;
};

export default BaseAmountTypeField;
